/* eslint-disable max-len */
var UI_CROSS = {
  "default": 'M31.63,29.87a1.24,1.24,0,0,1-1.76,1.76L16,17.77,2.13,31.63A1.24,1.24,0,0,1,.37,29.87L14.23,16,.37,2.13A1.24,1.24,0,0,1,2.13.37L16,14.23,29.87.37a1.24,1.24,0,0,1,1.76,1.76L17.77,16Z',
  globetrotter: 'M2.5 2.5L29.5 29.5M29.5 2.5L2.5 29.5'
};

export { UI_CROSS };
//# sourceMappingURL=UI_CROSS.js.map
